// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","miniPDP__container":"miniPDP_miniPDP__container__eSazp","border":"miniPDP_border__jmz4f"};